import { Component, Inject } from '@angular/core';
import { APP_CONSTANTS_TOKEN, AppConstants } from '../../core/constants';

@Component({
  selector: 'app-about',
  template: require('./about.component.html').default,
  styles: [require('!!raw-loader!sass-loader!./about.component.scss').default],
  standalone: false,
})
export class AboutComponent {
  message: string;

  constructor(@Inject(APP_CONSTANTS_TOKEN) private constants: AppConstants) {
    this.message = this.constants.appName;
  }
}
